import React from 'react'
import LenguageCard from '../components/LenguageCard'
import lenguages from './data';
import Slider from 'react-slick';
import { useTranslation } from 'react-i18next';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Lenguages = () => {
    const [t] = useTranslation("global");
    const settings = {
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 6,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 1367,
                settings: {
                    infinite: true,
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    speed: 500,
                    autoplay: true,
                    autoplaySpeed: 2000,
                }
            },
            {
                breakpoint: 1250,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    speed: 500,
                    autoplay: true,
                    autoplaySpeed: 2000,
                }
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    speed: 500,
                    autoplay: true,
                    autoplaySpeed: 2000,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    speed: 500,
                    autoplay: true,
                    autoplaySpeed: 2000,
                }
            }
        ]
    };
    return (
        
    <section className='Lenguages' id='Lenguajes'>
        <h1 className='Lenguages-title'>{t("Skills")}</h1>
        <div className='Lenguages-container'>
            <div className='Lenguages-slider'>
                <Slider {...settings} draggable>
                {
                    lenguages.map((lenguage) => (
                        <div className='Lenguage-card' key={lenguage.id}>
                            <LenguageCard image={lenguage.image} title={lenguage.name} />
                        </div>
                    ))
                }
                </Slider>
                {/* <div className='marquee'>
                    <ul className='list'>
                        {
                            lenguages.map((lenguage) => (
                                <li className='Lenguage-card' key={lenguage.id}>
                                    <LenguageCard image={lenguage.image} title={lenguage.name} />
                                </li>
                            ))
                        }
                    </ul>
                </div> */}
            </div>
        </div>
    </section>
    )
}

export default Lenguages
